import {
  CARDS,
  LOYALTY,
  LOYALTY_ROOT,
  RECOMMEND_APP,
  RECOMMEND_APP_PARTNERS,
  RECOMMEND_SETTINGS,
  SEGMENTS,
} from '@app/routes/iframe-routes/constants';

export const NO_TOOLTIP_TITLE = '';

export const DATA_TESTID_ATTRIBUTE = 'data-testid';

// Ключи (навигации)
export const SETTINGS_KEY = '61';
export const USERS_KEY = '18';
export const CLIENTS_KEY = '25';
export const PROFILE_KEY = '26';
export const EMPLOYEES_KEY = '32';
export const CLIENT_PAYMENTS_KEY = '58';
export const ANALYTICS_KEY = '59';
export const CONTROL_PANEL_KEY = '69';
export const LEADS_KEY = '73';
export const LEADS_KEY_1 = '173';
export const MESSAGES_KEY = '130';
export const MESSAGE_TEMPLATES_KEY = '90';
export const ADD_MESSAGE_TEMPLATE_KEY = '91';
export const EDIT_MESSAGE_TEMPLATE_KEY = '92';
export const SORTING_SERVICES_KEY = '78';
export const CHAINS_KEY = '14';
export const ADD_CHAIN_KEY = '16';
export const ADD_USER_KEY = '19';
export const ADD_BRANCH_KEY = '20';
export const EDIT_BRANCH_KEY = '21';
export const BRANCHES_PREVIEW_KEY = '22';
export const EDIT_USER_KEY = '23';
export const ADD_CLIENT_KEY = '27';
export const EDIT_CLIENT_KEY = '28';
export const CLIENT_CARD_KEY = '30';
export const TAGS_KEY = '31';
export const CLIENT_FIELDS_KEY = '148';
export const SUBSCRIPTIONS_KEY = '154';
export const CERTIFICATES_KEY = '155';
export const ADD_EMPLOYEE_KEY = '33';
export const POSITIONS_KEY = '34';
export const ADD_POSITION_KEY = '35';
export const EDIT_POSITION_KEY = '37';
export const CLIENT_SERVICES_KEY = '38';
export const EDIT_EMPLOYEE_KEY = '39';
export const EDIT_SERVICE_KEY = '45';
export const CATEGORIES_KEY = '41';
export const ADD_CATEGORY_KEY = '42';
export const EDIT_CATEGORY_KEY = '43';
export const ADD_SERVICE_KEY = '44';
export const CALENDAR_KEY = '46';
export const SCHEDULE_KEY = '47';
export const INDIVIDUAL_CALENDAR_KEY = '48';
export const RECORDS_KEY = '49';
export const IMPORT_SERVICES_KEY = '48';
export const IMPORT_EMPLOYEES_KEY = '50';
export const IMPORT_CLIENTS_KEY = '51';
export const IMPORT_RECORDS_KEY = '151';
export const IMPORT_PRODUCTS_KEY = '153';
export const LEGAL_ENTITIES_KEY = '52';
export const ADD_LEGAL_ENTITY_KEY = '53';
export const PAYMENTS_ACCOUNTS_KEY = '54';
export const ADD_PAYMENT_ACCOUNT_KEY = '55';
export const EDIT_PAYMENT_ACCOUNT_KEY = '56';
export const INTEGRATIONS_KEY = '57';
export const DIRECTION_INDICATORS_KEY = '60';
export const SALE_PLANS_KEY = '62';
export const DATA_MIGRATION_KEY = '63';
export const MIGRATION_CARD_KEY = '64';
export const OPERATIONS_KEY = '65';
export const ACTIONS_HISTORY_KEY = '67';
export const FILE_EXPORT_KEY = '68';
export const LEAD_CARD_KEY = '74';
export const BRANCHES_KEY = '75';
export const EDIT_LEGAL_ENTITY_KEY = '76';
export const SORT_EMPLOYEES_KEY = '77';
export const TASK_LIST_KEY = '79';
export const SALES_FUNNELS_KEY = '80';
export const VIEW_SALES_FUNNEL_KEY = '81';
export const EDIT_SALES_FUNNEL_KEY = '82';
export const ORGANIZATIONS_KEY = '83';
export const ORGANIZATION_SETTINGS_KEY = '84';
export const SENDOUTS_KEY = '85';
export const VIEW_SENDOUTS_KEY = '86';
export const SENDOUT_RECEIVERS_KEY = '87';
export const ORGANIZATION_USERS_KEY = '88';
export const ORGANIZATION_AI_SETTINGS_KEY = '90';
export const CALENDAR_SETTINGS_KEY = '93';
export const ORGANIZATION_CLIENTS_GROWTH_KEY = '94';
export const LOGS_REGISTRY_KEY = '95';
export const NOTIFICATIONS_KEY = '96';
export const FINANCIAL_RESULTS_REPORT_KEY = '97';
export const REVENUE_STATEMENT_KEY = '98';
export const WAREHOUSES_REGISTRY_KEY = '99';
export const BILLING_KEY = '140';
export const CREATE_WAREHOUSE_KEY = '101';
export const PRODUCTS_KEY = '102';
export const PRODUCT_CATEGORIES_KEY = '103';
export const ADD_PRODUCT_CATEGORY_KEY = '104';
export const EDIT_PRODUCT_CATEGORY_KEY = '105';
export const EDIT_WAREHOUSE_KEY = '106';
export const BRANDS_KEY = '107';
export const ADD_BRAND_KEY = '108';
export const EDIT_BRAND_KEY = '109';
export const SUPPLIERS_KEY = '110';
export const ADD_SUPPLIER_KEY = '111';
export const EDIT_SUPPLIER_KEY = '112';
export const WAREHOUSES_KEY = '115';
export const ADD_PRODUCT_KEY = '116';
export const WAREHOUSE_OPERATIONS_KEY = '117';
export const EDIT_PRODUCT_KEY = '118';
export const INVENTORY_KEY = '119';
export const ADD_INVENTORY_KEY = '120';
export const EDIT_INVENTORY_KEY = '121';
export const PRODUCT_DIRECTORY_KEY = '122';
export const GOODS_UNITS_KEY = '123';
export const ACTUAL_IMPLEMENTATION_KEY = '124';
export const GOODS_RECEIPT_KEY = '125';
export const GOODS_WRITE_OFF_KEY = '126';
export const GOODS_SALE_KEY = '127';
export const GOODS_TRANSFER_KEY = '128';
export const DELETE_PRODUCTS_KEY = '142';
export const DETAILS_OF_EXPENSES_KEY = '129';
export const EXPENSE_BY_ARTICLES_REPORT_KEY = '130';
export const SALARY_REPORT_KEY = '131';
export const BOOKING_KEY = '132';
export const INVENTORY_CARD_KEY = '133';
export const EDIT_SENDOUTS_KEY = '134';
export const INTEGRATIONS_PARSING_KEY = '135';
export const SALES_FUNNEL_LEADS_KEY = '136';
export const SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_KEY = '137';
export const AI_AGENTS_KEY = '138';
export const PURCHASE_PLANNING_SETTINGS_KEY = '139';
export const NEURAL_NETWORK_LOGS_SETTINGS_KEY = '140';
export const EMAIL_LOGS_SETTINGS_KEY = '141';
export const YOO_KASSA_SUCCESS_PAYMENT_KEY = '142';
export const PAYMENT_DOCUMENTS_KEY = '143';
export const ADD_PAYMENT_DOCUMENTS_KEY = '144';
export const DETACH_RESPONSIBLE_FROM_LEAD_KEY = '145';
export const ORGANIZATION_ANALYTICS_KEY = '146';
export const MEDICAL_CARD_REGISTRY_KEY = '147';
export const DOCUMENT_TEMPLATES_KEY = '149';
export const AI_PROMPTS_SETTINGS_KEY = '150';
export const PAID_AI_FEATURES_KEY = '152';

// Лейблы (групп страниц)
export const RECORD_SETTINGS_LABEL = 'Настройки записи';
export const SYSTEM_SETTINGS_LABEL = 'Системные настройки';
export const BRANCHES_AND_CHAINS_LABEL = 'Филиалы и сети';
export const PERSONAL_SETTINGS_LABEL = 'Личные настройки';
export const AI_OPERATOR_LABEL = 'ИИ-агент';

// Лейблы (страниц)
export const SETTINGS_LABEL = 'Настройки';
export const SALE_PLANS_LABEL = 'Планы продаж';
export const DATA_MIGRATION_LABEL = 'Миграция данных';
export const OPERATIONS_LABEL = 'Финансовые операции';
export const FINANCES_LABEL = 'Финансы';
export const CLIENT_SERVICES_LABEL = 'Услуги';
export const EDIT_CLIENT_SERVICES_LABEL = 'Редактирование услуги';
export const ADD_CLIENT_SERVICES_LABEL = 'Добавить услугу';
export const SERVICES_SORTING_LABEL = 'Сортировка услуг';
export const POSITIONS_LABEL = 'Должности';
export const CATEGORIES_LABEL = 'Категории услуг';
export const TAGS_LABEL = 'Теги';
export const CLIENT_FIELDS_LABEL = 'Дополнительные поля клиента';
export const SUBSCRIPTIONS_LABEL = 'Абонементы';
export const CERTIFICATES_LABEL = 'Сертификаты';
export const INTEGRATIONS_LABEL = 'Интеграции';
export const MCP_INTEGRATION_LABEL = 'MCP-коннектор';
export const PROXY_LABEL = 'Прокси';
export const BRANCHES_LABEL = 'Филиалы';
export const CHAINS_LABEL = 'Сети';
export const LEGAL_ENTITIES_LABEL = 'Юридические лица';
export const PAYMENTS_ACCOUNTS_LABEL = 'Кассы';
export const ACTIONS_HISTORY_LABEL = 'История действий';
export const CLIENTS_LABEL = 'Клиенты';
export const EMPLOYEES_LABEL = 'Исполнители';
export const SORT_EMPLOYEES_LABEL = 'Сортировка исполнителей';
export const ADD_EMPLOYEES_LABEL = 'Добавить исполнителя';
export const LEADS_LABEL = 'Лиды';
export const FILE_EXPORT_LABEL = 'Скачать файл экспорта';
export const CONTROL_PANEL_LABEL = 'Панель управления';
export const LEAD_CARD_LABEL = 'Сообщения';
export const ANALYTICS_LABEL = 'Аналитика';
export const RECORDS_LABEL = 'Записи';
export const USERS_LABEL = 'Пользователи';
export const WORK_SCHEDULES_LABEL = 'График работы';
export const RECORDS_JOURNAL_LABEL = 'Журнал записей';
export const PROFILE_LABEL = 'Личный кабинет';
export const MESSAGES_LABEL = 'Реестр сообщений';
export const MESSAGE_TEMPLATES_LABEL = 'Шаблоны сообщений';
export const ADD_MESSAGE_TEMPLATE_LABEL = 'Добавление шаблона';
export const EDIT_MESSAGE_TEMPLATE_LABEL = 'Редактирование шаблона';
export const ERROR_404_LABEL = 'Ошибка 404';
export const ADD_CHAIN_LABEL = 'Добавить сеть';
export const EDIT_CHAIN_LABEL = 'Редактировать сеть';
export const ADD_USER_LABEL = 'Добавить пользователя';
export const ADD_BRANCH_LABEL = 'Добавить филиал';
export const EDIT_BRANCH_LABEL = 'Редактировать филиал';
export const BRANCHES_PREVIEW_LABEL = 'Просмотр филиалов сети';
export const EDIT_USER_LABEL = 'Редактировать пользователя';
export const ADD_CLIENT_LABEL = 'Добавить клиента';
export const EDIT_CLIENT_LABEL = 'Редактировать клиента';
export const CLIENT_CARD_LABEL = 'Карточка клиента';
export const ADD_POSITION_LABEL = 'Добавить должность';
export const EDIT_POSITION_LABEL = 'Редактировать должность';
export const EMAIL_VERIFICATION_LABEL = 'Подтверждение смены пароля';
export const EDIT_EMPLOYEE_LABEL = 'Редактировать исполнителя';
export const ADD_CATEGORY_LABEL = 'Добавить категорию';
export const EDIT_CATEGORY_LABEL = 'Редактировать категорию';
export const IMPORT_SERVICES_LABEL = 'Импорт услуг';
export const IMPORT_EMPLOYEES_LABEL = 'Импорт исполнителей';
export const IMPORT_CLIENTS_LABEL = 'Импорт клиентов';
export const IMPORT_RECORDS_LABEL = 'Импорт записей';
export const IMPORT_PRODUCTS_LABEL = 'Импорт товаров';
export const ADD_LEGAL_ENTITY_LABEL = 'Добавить юридическое лицо';
export const ADD_PAYMENT_ACCOUNT_LABEL = 'Добавить кассу';
export const EDIT_PAYMENT_ACCOUNT_LABEL = 'Редактировать кассу';
export const DIRECTION_INDICATORS_LABEL = 'Показатели направлений';
export const MIGRATION_CARD_LABEL = 'Карточка миграции';
export const EDIT_LEGAL_ENTITY_LABEL = 'Редактировать юридическое лицо';
export const TASK_LIST_LABEL = 'Задачи';
export const SALES_FUNNELS_LABEL = 'Воронки продаж';
export const VIEW_SALES_FUNNEL_LABEL = 'Воронка продаж';
export const EDIT_SALES_FUNNEL_LABEL = 'Редактирование воронки продаж';
export const ORGANIZATIONS_LABEL = 'Организации';
export const ORGANIZATION_SETTINGS_LABEL = 'Настройки организации';
export const ORGANIZATION_USERS_LABEL = 'Пользователи';
export const ORGANIZATION_AI_SETTINGS_LABEL = 'Настройка ИИ';
export const SENDOUTS_LABEL = 'Рассылки';
export const EDIT_SENDOUTS_LABEL = 'Редактирование рассылки';
export const VIEW_SENDOUTS_LABEL = 'Просмотр рассылки';
export const SENDOUT_RECEIVERS_LABEL = 'Получатели рассылки';
export const CALENDAR_SETTINGS_LABEL = 'Настройки журнала записей';
export const ORGANIZATION_CLIENTS_GROWTH_LABEL = 'Клиенты';
export const LOGS_REGISTRY_LABEL = 'Логи';
export const NOTIFICATIONS_LABEL = 'Уведомления';
export const FINANCIAL_RESULTS_REPORT_LABEL =
  'Финансовые результаты филиала (PnL)';
export const REVENUE_STATEMENT_LABEL = 'Доходы филиала';
export const WAREHOUSES_LABEL = 'Склад';
export const BILLING_LABEL = 'Биллинг';
export const WAREHOUSES_REGISTRY_LABEL = 'Склады';
export const CREATE_WAREHOUSE_LABEL = 'Создание склада';
export const EDIT_WAREHOUSE_LABEL = 'Редактирование склада';
export const PRODUCTS_LABEL = 'Товары склада';
export const PRODUCT_CATEGORIES_LABEL = 'Категории товаров';
export const ADD_PRODUCT_CATEGORY_LABEL = 'Добавление категории товаров';
export const EDIT_PRODUCT_CATEGORY_LABEL = 'Редактирование категории товаров';
export const BRANDS_LABEL = 'Бренды';
export const ADD_BRAND_LABEL = 'Добавление бренда';
export const EDIT_BRAND_LABEL = 'Редактирование бренда';
export const SUPPLIERS_LABEL = 'Поставщики';
export const ADD_SUPPLIER_LABEL = 'Добавление поставщика';
export const EDIT_SUPPLIER_LABEL = 'Редактирование поставщика';
export const ADD_PRODUCT_LABEL = 'Добавление товара';
export const EDIT_PRODUCT_LABEL = 'Редактирование товара';
export const WAREHOUSE_OPERATIONS_LABEL = 'Складские операции';
export const INVENTORY_LABEL = 'Инвентаризация';
export const ADD_INVENTORY_LABEL = 'Добавление инвентаризации';
export const EDIT_INVENTORY_LABEL = 'Редактирование инвентаризации';
export const PRODUCT_DIRECTORY_LABEL = 'Справочник товаров';
export const GOODS_UNITS_LABEL = 'Товарные единицы';
export const ACTUAL_IMPLEMENTATION_LABEL = 'Реализация филиала';
export const GOODS_RECEIPT_LABEL = 'Приход товара';
export const GOODS_WRITE_OFF_LABEL = 'Списание товара';
export const DELETE_PRODUCTS_LABEL = 'Удаление товара';
export const GOODS_SALE_LABEL = 'Продажа товара';
export const DETAILS_OF_EXPENSES_LABEL = 'Расходы филиала';
export const EXPENSE_BY_ARTICLES_REPORT_LABEL = 'Детализация расходов филиала';
export const BOOKING_LABEL = 'Онлайн записи';
export const SALARY_REPORT_LABEL = 'Зарплата';
export const GOODS_TRANSFER_LABEL = 'Перемещение товара';
export const INVENTORY_CARD_LABEL = 'Инвентаризация';
export const BRANCH_INDICATORS_REPORT_LABEL = 'Показатели филиалов';
export const INTEGRATIONS_PARSING_LABEL =
  'Настройка парсинга электронных писем';
export const SALES_FUNNEL_LEADS_LABEL = 'Лиды воронки продаж';
export const SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_LABEL =
  'Автоматическая отправка сообщений';
export const AI_PROMPTS_SETTINGS_LABEL = 'Настройка ИИ-автоответов';
export const PAID_AI_FEATURES_LABEL = 'Платные ИИ-функции';
export const DETACH_RESPONSIBLE_FROM_LEAD_LABEL =
  'Открепление ответственного от лида';
export const AI_AGENTS_LABEL = 'ИИ-чат';
export const PURCHASE_PLANNING_SETTINGS_LABEL =
  'Настройка планирования закупок';
export const PURCHASE_PLANNING_LABEL = 'Планирование закупок';
export const NEURAL_NETWORK_LOGS_SETTINGS_LABEL = 'Логи запросов к GPT';
export const EMAIL_LOGS_SETTINGS_LABEL = 'Логирование';
export const YOO_KASSA_SUCCESS_PAYMENT_LABEL =
  'Страница успешной оплаты ЮKassa';
export const PAYMENT_DOCUMENTS_LABEL = 'Документы оплаты';
export const ADD_PAYMENT_DOCUMENTS_LABEL = 'Создать счёт';
export const YOO_KASSA_PAYMENT_WITH_EMAIL_LABEL = 'Оплата визита';
export const ORGANIZATION_ANALYTICS_LABEL = 'Аналитика организации';
export const MEDICAL_CARD_REGISTRY_LABEL = 'Медицинские карты';
export const DOCUMENT_TEMPLATES_LABEL = 'Шаблоны документов';

// Идентификаторы
export const ADD = 'add';
export const EDIT = 'edit';
export const IMPORT = 'import';
export const CARD = 'card';
export const AUTHORIZATION = 'authorization';
export const REGISTRATION = 'sign-up';
export const OPERATIONS = 'operations';
export const SENDER = 'sender';
export const ACTIONS_HISTORY = 'actions-history';
export const ANALYTICS = 'analytics';
export const TAGS = 'tags';
export const CLIENT_FIELDS = 'client-fields';
export const SUBSCRIPTIONS = 'subscriptions';
export const CERTIFICATES = 'certificates';
export const SETTINGS = 'crm-settings';
export const USERS = 'users';
export const BRANCHES = 'branches';
export const CLIENTS = 'clients';
export const PROFILE = 'profile';
export const EMPLOYEES = 'employees';
export const POSITIONS = 'positions';
export const SERVICES = 'services';
export const CALENDAR = 'calendar';
export const INDIVIDUAL_CALENDAR = 'individual-calendar';
export const SCHEDULE = 'schedule';
export const RECORDS = 'records';
export const CLIENT_PAYMENTS = 'client-payments';
export const LEADS = 'leads';
export const LEADS_SALES_FUNNELS = 'leads-sales-funnels';
export const FILE_EXPORT = 'file-for-download';
export const CONTROL_PANEL = 'control-panel';
export const MESSAGES = 'messages';
export const MESSAGE_TEMPLATES = 'message-templates';
export const ADD_MESSAGE_TEMPLATE = 'add-message-template';
export const EDIT_MESSAGE_TEMPLATE = 'edit-message-template';
export const SORTING = 'sorting';
export const CHAINS_ID = 'chains';
export const ADD_CHAIN = 'add-chain';
export const EDIT_CHAIN = 'edit-chain';
export const ADD_USER_ID = 'add-user';
export const ERROR_404 = 'error-404';
export const HEALTH_CHECK = 'health-check';
export const ADD_BRANCH = 'add-branch';
export const EDIT_BRANCH = 'edit-branch';
export const BRANCHES_PREVIEW = 'branches-preview';
export const EDIT_USER = 'edit-user';
export const USER_PROFILE = 'user-profile';
export const ADD_CLIENT = 'add-client';
export const EDIT_CLIENT = 'edit-client';
export const CLIENT_CARD = 'client-card';
export const ADD_POSITION = 'add-position';
export const EDIT_POSITION = 'edit-position';
export const EMAIL_VERIFICATION = 'email-verification';
export const CLIENT_SERVICES = 'client-services';
export const EDIT_EMPLOYEE = 'edit-employee';
export const EDIT_CLIENT_SERVICES = 'edit-client-service';
export const CATEGORIES = 'service-categories';
export const ADD_CATEGORY = 'add-service-category';
export const EDIT_SERVICE_CATEGORY = 'edit-service-category';
export const ADD_SERVICE = 'add-client-service';
export const IMPORT_SERVICES = 'import-services';
export const IMPORT_EMPLOYEES = 'import-employees';
export const IMPORT_CLIENTS = 'import-clients';
export const IMPORT_RECORDS = 'import-records';
export const IMPORT_PRODUCTS = 'import-products';
export const LEGAL_ENTITIES_ID = 'legal-entities';
export const ADD_LEGAL_ENTITY = 'add-legal-entity';
export const PAYMENTS_ACCOUNTS = 'payment-accounts';
export const ADD_PAYMENT_ACCOUNT = 'add-payment-accounts';
export const EDIT_PAYMENT_ACCOUNT = 'edit-payment-accounts';
export const INTEGRATIONS = 'integrations';
export const MCP_INTEGRATION = 'ai-mcp';
export const MCP_INTEGRATION_LEGACY = 'ai-mcp-legacy';
export const MCP_LOGIN = 'mcp-login';
export const MCP_APPROVAL = 'mcp-approval';
export const PROXY = 'proxy';
export const DIRECTION_INDICATORS = 'direction-indicators';
export const SALE_PLANS_ID = 'sale-plans';
export const DATA_MIGRATION = 'data-migration';
export const MIGRATION_CARD = 'data-migration-viewer';
export const EDIT_LEGAL_ENTITY = 'edit-legal-entity';
export const SORT_EMPLOYEES = 'sort-employees';
export const TASK_LIST = 'task-list';
export const SALES_FUNNELS = 'sales-funnels';
export const VIEW_SALES_FUNNEL = 'view-sales-funnel';
export const EDIT_SALES_FUNNEL = 'edit-sales-funnel';
export const ORGANIZATIONS = 'organizations';
export const ORGANIZATION_SETTINGS = 'organization-settings';
export const ORGANIZATION_USERS = 'organization-users';
export const ORGANIZATION_AI_SETTINGS = 'organization-ai-settings';
export const SENDOUTS = 'sendouts';
export const VIEW_SENDOUTS = 'view-sendouts';
export const SENDOUT_RECEIVERS = 'sendout-receivers';
export const CALENDAR_SETTINGS_ID = 'calendar-settings';
export const ORGANIZATION_CLIENTS_GROWTH = 'organization-clients-growth';
export const LOGS_REGISTRY = 'logs-registry';
export const NOTIFICATIONS = 'notifications';
export const FINANCIAL_RESULTS_REPORT = 'financial-results-report';
export const REVENUE_STATEMENT = 'revenue-statement';
export const WAREHOUSES = 'warehouses';
export const BILLING = 'billing';
export const WAREHOUSES_REGISTRY = 'warehouses-registry';
export const CREATE_WAREHOUSE = 'create-warehouse';
export const EDIT_WAREHOUSE = 'edit-warehouse';
export const PRODUCT_CATEGORIES = 'product-categories';
export const ADD_PRODUCT_CATEGORY = 'add-product-categories';
export const EDIT_PRODUCT_CATEGORY = 'edit-product-categories';
export const BRANDS = 'brands';
export const ADD_BRAND = 'add-brand';
export const EDIT_BRAND = 'edit-brand';
export const SUPPLIERS = 'suppliers';
export const ADD_SUPPLIER = 'add-supplier';
export const EDIT_SUPPLIER = 'edit-supplier';
export const WAREHOUSE_OPERATIONS = 'warehouse-operations';
export const ADD_PRODUCT = 'add-product';
export const EDIT_PRODUCT = 'edit-product';
export const INVENTORY = 'inventory';
export const PRODUCT_DIRECTORY = 'product-directory';
export const GOODS_UNITS = 'goods-units';
export const ACTUAL_IMPLEMENTATION = 'actual-implementation';
export const GOODS_RECEIPT = 'goods-receipt';
export const GOODS_WRITE_OFF = 'goods-write-off';
export const GOODS_SALE = 'goods-sale';
export const GOODS_TRANSFER = 'goods-transfer';
export const DELETE_PRODUCTS = 'goods-delete';
export const DETAILS_OF_EXPENSES = 'details-of-expenses';
export const EXPENSE_BY_ARTICLES_REPORT = 'expense-by-articles-report';
export const BOOKING = 'online-booking';
export const SALARY_REPORT = 'salary-report';
export const PRODUCTS = 'products';
export const ADD_INVENTORY = 'add-inventory';
export const EDIT_INVENTORY = 'edit-inventory';
export const INVENTORY_CARD = 'inventory-card';
export const BRANCH_INDICATORS_REPORT = 'branch-indicators';
export const EDIT_SENDOUTS = 'edit-sendouts';
export const INTEGRATIONS_PARSING = 'integrations-parsing';
export const SALES_FUNNEL_LEADS = 'sales-funnel-leads';
export const SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS =
  'setting-up-automatic-messaging-to-clients';
export const AI_PROMPTS_SETTINGS = 'ai-prompts-settings';
export const PAID_AI_FEATURES = 'paid-ai-features';
export const AI_AGENTS = 'ai-agents';
export const PURCHASE_PLANNING_SETTINGS = 'purchase-planning-settings';
export const NEURAL_NETWORK_LOGS_SETTINGS = 'neural-network-logs';
export const EMAIL_LOGS_SETTINGS = 'email-logs';
export const YOO_KASSA_SUCCESS_PAYMENT = 'yoo-kassa-success-payment';
export const PAYMENT_DOCUMENTS = 'payment-documents';
export const ADD_PAYMENT_DOCUMENTS = 'add-payment-documents';
export const YOO_KASSA_PAYMENT_WITH_EMAIL = 'yoo-kassa-payment-with-email';
export const DETACH_RESPONSIBLE_FROM_LEAD = 'detach-responsible-from-lead';
export const ORGANIZATION_ANALYTICS = 'organization-analytics';
export const MEDICAL_CARD_REGISTRY = 'medical-card-registry';
export const DOCUMENT_TEMPLATES = 'document-templates';

// Пути
export const HOME_PAGE_PATH = '/';
export const AUTHORIZATION_PATH = `/${AUTHORIZATION}`;
export const REGISTRATION_PATH = `/${REGISTRATION}`;
export const TAGS_PATH = `/${TAGS}`;
export const CLIENT_FIELDS_PATH = `/${CLIENT_FIELDS}`;
export const SUBSCRIPTIONS_PATH = `/${SUBSCRIPTIONS}`;
export const CERTIFICATES_PATH = `/${CERTIFICATES}`;
export const EMPLOYEES_PATH = `/${EMPLOYEES}`;
export const SORT_EMPLOYEES_PATH = `/sort/${EMPLOYEES}`;
export const POSITIONS_PATH = `/${POSITIONS}`;
export const SETTINGS_PATH = '/crm-settings';
export const LEGAL_ENTITIES_PATH = `/${LEGAL_ENTITIES_ID}`;
export const SALE_PLANS_PATH = '/sales-plans';
export const DATA_MIGRATION_PATH = '/data-migration';
export const CLIENT_SERVICES_PATH = '/services';
export const SERVICES_SORTING_PATH = `${CLIENT_SERVICES_PATH}/${SORTING}`;
export const CATEGORIES_PATH = '/categories';
export const INTEGRATIONS_PATH = `/${INTEGRATIONS}`;
// Адреса страниц MCP закреплены и на стороне коннектора (ссылка «Открыть CRM»,
// CRM_BROWSER_URL, APPROVAL_PAGE_ORIGIN) — менять только вместе с ним.
export const MCP_INTEGRATION_PATH = `/${MCP_INTEGRATION}`;
// Прежний адрес страницы: на него ведёт ссылка «Открыть CRM» в коннекторе,
// пока она не переведена на MCP_INTEGRATION_PATH.
export const MCP_INTEGRATION_LEGACY_PATH = `${INTEGRATIONS_PATH}/${MCP_INTEGRATION}`;
export const MCP_LOGIN_PATH = '/mcp/login';
export const MCP_APPROVALS_PATH = '/mcp/approvals';
export const MCP_APPROVAL_PATH = `${MCP_APPROVALS_PATH}/:draftId`;
export const PROXY_PATH = `/${PROXY}`;
export const PROXY_ROUTE_PATH = `${PROXY_PATH}/*`;
export const BRANCHES_PATH = '/branches';
export const CHAINS_PATH = '/chains';
export const PAYMENTS_ACCOUNTS_PATH = '/payment-accounts';
export const CALENDAR_PATH = `/${CALENDAR}`;
export const INDIVIDUAL_CALENDAR_PATH = `/${CALENDAR}/individual`;
export const ANALYTICS_PATH = `/${ANALYTICS}`;
export const OPERATIONS_PATH = `/${OPERATIONS}`;
export const ACTIONS_HISTORY_PATH = `/${ACTIONS_HISTORY}`;
export const AI_ACTIONS_HISTORY_PATH = `/${ACTIONS_HISTORY}?user=ai`;
export const SENDER_PATH = `/${SENDER}`;
export const USERS_PATH = `/${USERS}`;
export const USERS_EDIT_PATH = `/${USERS}/${EDIT}`;
export const CLIENTS_PATH = `/${CLIENTS}`;
export const PROFILE_PATH = `/${PROFILE}`;
export const SERVICES_PATH = `/${SERVICES}`;
export const SCHEDULE_PATH = `/${SCHEDULE}`;
export const RECORDS_PATH = `/${RECORDS}`;
export const BILLING_PATH = `/${BILLING}`;
export const CLIENT_PAYMENTS_PATH = `/${CLIENT_PAYMENTS}`;
export const CLIENTS_EXPORT_PATH = `${CLIENTS_PATH}/${FILE_EXPORT}`;
export const LEADS_PATH = `/${LEADS}`;
export const FILE_EXPORT_PATH = `/${FILE_EXPORT}`;
export const CONTROL_PANEL_PATH = `/${CONTROL_PANEL}`;
export const LEAD_CARD_PATH = `${LEADS_PATH}/${CARD}`;
export const SALES_FUNNELS_LEADS_PATH = `${LEADS_PATH}/funnels`;
export const SALES_FUNNELS_LEAD_CARD_PATH = `${LEADS_PATH}/funnels/${CARD}`;
export const MESSAGES_PATH = `/${MESSAGES}`;
export const MESSAGE_TEMPLATES_PATH = `/${MESSAGE_TEMPLATES}`;
export const ADD_MESSAGE_TEMPLATE_PATH = `/${MESSAGE_TEMPLATES}/${ADD}/`;
export const EDIT_MESSAGE_TEMPLATE_PATH = `/${MESSAGE_TEMPLATES}/${EDIT}/`;
export const ADD_CLIENT_SERVICES_PATH = `${CLIENT_SERVICES_PATH}/${ADD}/?key=1`;
export const ADD_SERVICE_CATEGORY_PATH = `/categories/${ADD}/`;
export const EDIT_SERVICE_CATEGORY_PATH = `/categories/${EDIT}/?id=`;
export const BRANCHES_PREVIEW_PATH = `${CHAINS_PATH}/${BRANCHES_PREVIEW}/`;
export const CLIENT_CARD_PATH = `${CLIENTS_PATH}/${CARD}/`;
export const ADD_POSITION_PATH = `${POSITIONS_PATH}/${ADD}/`;
export const EDIT_POSITION_PATH = `${POSITIONS_PATH}/${EDIT}/`;
export const EMAIL_VERIFICATION_PATH = '/email-verification';
export const EDIT_EMPLOYEE_PATH = `${EMPLOYEES_PATH}/${EDIT}/`;
export const EDIT_SERVICE_PATH = `${SERVICES_PATH}/${EDIT}/`;
export const ADD_CATEGORY_PATH = `${CATEGORIES_PATH}/${ADD}/`;
export const EDIT_CATEGORY_PATH = `${CATEGORIES_PATH}/${EDIT}/`;
export const ADD_SERVICE_PATH = `${SERVICES_PATH}/${ADD}/`;
export const IMPORT_SERVICES_PATH = `${SERVICES_PATH}/${IMPORT}`;
export const IMPORT_EMPLOYEES_PATH = `${EMPLOYEES_PATH}/${IMPORT}`;
export const IMPORT_CLIENTS_PATH = `${CLIENTS_PATH}/${IMPORT}`;
export const IMPORT_RECORDS_PATH = `${RECORDS_PATH}/${IMPORT}`;
export const ADD_LEGAL_ENTITY_PATH = `${LEGAL_ENTITIES_PATH}/${ADD}/`;
export const ADD_PAYMENT_ACCOUNT_PATH = `${PAYMENTS_ACCOUNTS_PATH}/${ADD}/`;
export const EDIT_PAYMENT_ACCOUNT_PATH = `${PAYMENTS_ACCOUNTS_PATH}/${EDIT}/`;
export const DIRECTION_INDICATORS_PATH = `${ANALYTICS_PATH}/${DIRECTION_INDICATORS}/`;
export const ORGANIZATION_CLIENTS_GROWTH_PATH = `${ANALYTICS_PATH}/${ORGANIZATION_CLIENTS_GROWTH}/`;
export const MIGRATION_CARD_PATH = `${DATA_MIGRATION_PATH}/${CARD}/`;
export const EDIT_LEGAL_ENTITY_PATH = `${LEGAL_ENTITIES_PATH}/${EDIT}/`;
export const TASK_LIST_PATH = `/${TASK_LIST}`;
export const SALES_FUNNELS_PATH = `/${SALES_FUNNELS}`;
export const VIEW_SALES_FUNNEL_PATH = `/${SALES_FUNNELS}/view/`;
export const EDIT_SALES_FUNNEL_PATH = `/${SALES_FUNNELS}/edit/`;
export const ORGANIZATIONS_PATH = `/${ORGANIZATIONS}`;
export const ORGANIZATION_AI_SETTINGS_PATH = `${ORGANIZATIONS_PATH}-ai`;
export const SENDOUTS_PATH = `/${SENDOUTS}`;
export const EDIT_SENDOUTS_PATH = `${SENDOUTS_PATH}/${EDIT}`;
export const VIEW_SENDOUTS_PATH = `/${SENDOUTS}/view/`;
export const SENDOUT_RECEIVERS_PATH = `/${SENDOUT_RECEIVERS}/`;
export const CALENDAR_SETTINGS_PATH = '/settings/calendar';
export const LOGS_REGISTRY_PATH = `/${LOGS_REGISTRY}`;
export const NOTIFICATIONS_PATH = `/${NOTIFICATIONS}`;
export const FINANCIAL_RESULTS_REPORT_PATH = `${ANALYTICS_PATH}/${FINANCIAL_RESULTS_REPORT}/`;
export const REVENUE_STATEMENT_PATH = `${ANALYTICS_PATH}/${REVENUE_STATEMENT}/`;
export const ACTUAL_IMPLEMENTATION_PATH = `${ANALYTICS_PATH}/${ACTUAL_IMPLEMENTATION}/`;
export const DETAILS_OF_EXPENSES_PATH = `${ANALYTICS_PATH}/${DETAILS_OF_EXPENSES}/`;
export const EXPENSE_BY_ARTICLES_REPORT_PATH = `${ANALYTICS_PATH}/${EXPENSE_BY_ARTICLES_REPORT}/`;
export const SALARY_REPORT_PATH = `${ANALYTICS_PATH}/${SALARY_REPORT}/`;
export const EDIT_CLIENT_PATH = `${CLIENTS_PATH}/edit/`;
export const SALES_FUNNEL_LEADS_PATH = `/${SALES_FUNNEL_LEADS}/`;
export const SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS_PATH = `/${SETTING_UP_AUTOMATIC_MESSAGING_TO_CLIENTS}/`;
export const AI_PROMPTS_SETTINGS_PATH = `/${AI_PROMPTS_SETTINGS}/`;
export const PAID_AI_FEATURES_PATH = `/${PAID_AI_FEATURES}/`;
export const DETACH_RESPONSIBLE_FROM_LEAD_PATH = `/${DETACH_RESPONSIBLE_FROM_LEAD}/`;

export const WAREHOUSES_PATH = `/${WAREHOUSES}`;
export const CREATE_WAREHOUSE_PATH = `${WAREHOUSES_PATH}/${ADD}`;
export const EDIT_WAREHOUSE_PATH = `${WAREHOUSES_PATH}/${EDIT}`;

export const BRANDS_PATH = `${WAREHOUSES_PATH}/${BRANDS}`;
export const ADD_BRAND_PATH = `${BRANDS_PATH}/${ADD}`;
export const EDIT_BRAND_PATH = `${BRANDS_PATH}/${EDIT}`;

export const SUPPLIERS_PATH = `${WAREHOUSES_PATH}/${SUPPLIERS}`;
export const ADD_SUPPLIER_PATH = `${SUPPLIERS_PATH}/${ADD}`;
export const EDIT_SUPPLIER_PATH = `${SUPPLIERS_PATH}/${EDIT}`;

export const PRODUCT_CATEGORIES_PATH = `${WAREHOUSES_PATH}/${PRODUCT_CATEGORIES}`;
export const ADD_PRODUCT_CATEGORY_PATH = `${PRODUCT_CATEGORIES_PATH}/${ADD}`;
export const EDIT_PRODUCT_CATEGORY_PATH = `${PRODUCT_CATEGORIES_PATH}/${EDIT}`;

export const INVENTORY_PATH = `${WAREHOUSES_PATH}/${INVENTORY}`;
export const ADD_INVENTORY_PATH = `${INVENTORY_PATH}/${ADD}`;
export const EDIT_INVENTORY_PATH = `${INVENTORY_PATH}/${EDIT}`;
export const INVENTORY_CARD_PATH = `${INVENTORY_PATH}/:inventoryId`;

export const PRODUCTS_PATH = `${WAREHOUSES_PATH}/${PRODUCTS}`;
export const ADD_PRODUCT_PATH = `${PRODUCTS_PATH}/${ADD}`;
export const EDIT_PRODUCT_PATH = `${PRODUCTS_PATH}/${EDIT}`;
export const IMPORT_PRODUCTS_PATH = `${PRODUCTS_PATH}/${IMPORT}`;

export const WAREHOUSE_OPERATIONS_PATH = `${WAREHOUSES_PATH}/${OPERATIONS}`;
export const GOODS_UNITS_PATH = `${WAREHOUSES_PATH}/${GOODS_UNITS}`;
export const GOODS_RECEIPT_PATH = `${WAREHOUSE_OPERATIONS_PATH}/${GOODS_RECEIPT}`;
export const GOODS_WRITE_OFF_PATH = `${WAREHOUSE_OPERATIONS_PATH}/${GOODS_WRITE_OFF}`;
export const GOODS_SALE_PATH = `${WAREHOUSE_OPERATIONS_PATH}/${GOODS_SALE}`;
export const GOODS_TRANSFER_PATH = `${WAREHOUSE_OPERATIONS_PATH}/${GOODS_TRANSFER}`;
export const DELETE_PRODUCTS_PATH = `${PRODUCTS_PATH}/${DELETE_PRODUCTS}`;

export const WAREHOUSES_REGISTRY_PATH = `${WAREHOUSES_PATH}/${WAREHOUSES_REGISTRY}`;

export const PRODUCT_DIRECTORY_PATH = `${WAREHOUSES_PATH}/${PRODUCT_DIRECTORY}`;

export const BOOKING_PATH = `/${BOOKING}`;
export const INTEGRATIONS_PARSING_PATH = `/${INTEGRATIONS_PARSING}`;
export const AI_AGENTS_PATH = `/${AI_AGENTS}`;
export const PURCHASE_PLANNING_SETTINGS_PATH = `${WAREHOUSES_PATH}/${PURCHASE_PLANNING_SETTINGS}`;
export const NEURAL_NETWORK_LOGS_SETTINGS_PATH = `/${NEURAL_NETWORK_LOGS_SETTINGS}`;
export const EMAIL_LOGS_SETTINGS_PATH = `/${EMAIL_LOGS_SETTINGS}`;
export const YOO_KASSA_SUCCESS_PAYMENT_PATH = `/${YOO_KASSA_SUCCESS_PAYMENT}`;
export const PAYMENT_DOCUMENTS_PATH = `/${PAYMENT_DOCUMENTS}`;
export const ADD_PAYMENT_DOCUMENTS_PATH = `/${ADD_PAYMENT_DOCUMENTS}`;
export const YOO_KASSA_PAYMENT_WITH_EMAIL_PATH = `/${YOO_KASSA_PAYMENT_WITH_EMAIL}`;
export const ORGANIZATION_ANALYTICS_PATH = `/${ORGANIZATION_ANALYTICS}`;
export const MEDICAL_CARD_REGISTRY_PATH = `/${MEDICAL_CARD_REGISTRY}`;
export const DOCUMENT_TEMPLATES_PATH = `/${DOCUMENT_TEMPLATES}`;

// Боковое меню системы
export const SIDEBAR_PARENTS = [
  {
    id: SETTINGS,
    navigationKey: SETTINGS_KEY,
  },
  {
    id: CLIENTS,
    navigationKey: CLIENTS_KEY,
  },
  {
    id: PROFILE,
    navigationKey: PROFILE_KEY,
  },
  {
    id: EMPLOYEES,
    navigationKey: EMPLOYEES_KEY,
  },
  {
    id: CALENDAR,
    navigationKey: CALENDAR_KEY,
  },
  {
    id: SCHEDULE,
    navigationKey: SCHEDULE_KEY,
  },
  {
    id: RECORDS,
    navigationKey: RECORDS_KEY,
  },
  {
    id: CLIENT_PAYMENTS,
    navigationKey: CLIENT_PAYMENTS_KEY,
  },
  {
    id: BILLING,
    navigationKey: BILLING_KEY,
  },
  {
    id: ANALYTICS,
    navigationKey: ANALYTICS_KEY,
  },
  {
    id: CONTROL_PANEL,
    navigationKey: CONTROL_PANEL_KEY,
  },
  {
    id: TASK_LIST,
    navigationKey: TASK_LIST_KEY,
  },
  {
    id: SALES_FUNNELS,
    navigationKey: SALES_FUNNELS_KEY,
  },
  {
    id: LEADS,
    navigationKey: LEADS_KEY,
  },
  {
    id: LEADS_SALES_FUNNELS,
    navigationKey: LEADS_SALES_FUNNELS,
  },
  {
    id: ORGANIZATIONS,
    navigationKey: ORGANIZATIONS_KEY,
  },
  {
    id: SENDOUTS,
    navigationKey: SENDOUTS_KEY,
  },
  {
    id: WAREHOUSES,
    navigationKey: WAREHOUSES_KEY,
  },
  {
    id: WAREHOUSES_REGISTRY,
    navigationKey: WAREHOUSES_REGISTRY_KEY,
  },
  {
    id: WAREHOUSE_OPERATIONS,
    navigationKey: WAREHOUSE_OPERATIONS_KEY,
  },
  {
    id: PRODUCT_DIRECTORY,
    navigationKey: PRODUCT_DIRECTORY_KEY,
  },
  {
    id: PRODUCTS,
    navigationKey: PRODUCTS_KEY,
  },
  {
    id: INVENTORY,
    navigationKey: INVENTORY_KEY,
  },
  {
    id: BOOKING,
    navigationKey: BOOKING,
  },
  {
    id: RECOMMEND_APP,
    navigationKey: RECOMMEND_APP,
  },
  {
    id: RECOMMEND_APP_PARTNERS,
    navigationKey: RECOMMEND_APP_PARTNERS,
  },
  {
    id: RECOMMEND_SETTINGS,
    navigationKey: RECOMMEND_SETTINGS,
  },
  {
    id: SEGMENTS,
    navigationKey: SEGMENTS,
  },
  {
    id: LOYALTY,
    navigationKey: LOYALTY,
  },
  {
    id: CARDS,
    navigationKey: CARDS,
  },
  {
    id: LOYALTY_ROOT,
    navigationKey: LOYALTY_ROOT,
  },
  {
    id: AI_AGENTS,
    navigationKey: AI_AGENTS_KEY,
  },
  {
    id: MEDICAL_CARD_REGISTRY,
    navigationKey: MEDICAL_CARD_REGISTRY_KEY,
  },
];
